import {
  SAVE_VIRTUAL_AIRCRAFT_CONTRACT_ENTRY,
  SAVE_VIRTUAL_AIRCRAFT_CONTRACT_REQUEST,
  SAVE_VIRTUAL_AIRCRAFT_CONTRACT_SUCCESS,
  SAVE_VIRTUAL_AIRCRAFT_CONTRACT_FAILURE,
} from "./actionTypes";

export const saveVirtualAircraftContract = (payload) => ({
  type: SAVE_VIRTUAL_AIRCRAFT_CONTRACT_ENTRY,
  payload,
});

export const saveVirtualAircraftContractRequest = () => ({
  type: SAVE_VIRTUAL_AIRCRAFT_CONTRACT_REQUEST,
});

export const saveVirtualAircraftContractSuccess = (response) => ({
  type: SAVE_VIRTUAL_AIRCRAFT_CONTRACT_SUCCESS,
  payload: response,
});

export const saveVirtualAircraftContractFailure = (error) => ({
  type: SAVE_VIRTUAL_AIRCRAFT_CONTRACT_FAILURE,
  payload: error,
});
